import React from 'react';
import { DeviceMethodsSideBar } from '../deviceMethodsSideBar/deviceMethodsSideBar';
import { MultipleDevicesSelectedMethodsProps } from './multipleDevicesSelectedMethodsProps';
import {
  StyledContainerItems,
  StyledTitleSideBar
} from '../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import Strings from '../../../i18n';

export const MultipleDevicesSelectedMethods = ({
  reloadTable,
  openRightSideBarForMethod,
  selectedDevice,
  openRightSideBar,
  setOpenRightSideBar,
  deviceLocationView,
  clearSingleDevice
}: MultipleDevicesSelectedMethodsProps) => {
  const isOldGeneration = 5;

  return (
    <div>
      <StyledContainerItems>
        <StyledTitleSideBar>
          {Strings.serverAccess.devices.editMultipleDevices}
        </StyledTitleSideBar>
        <DeviceMethodsSideBar
          macAddress={selectedDevice.map((item: any) => item.deviceId)}
          reloadTable={reloadTable}
          openRightSideBarForMethod={openRightSideBarForMethod}
          deviceIds={selectedDevice.map((item: any) => item.deviceId)}
          openRightSideBar={openRightSideBar}
          setOpenRightSideBar={setOpenRightSideBar}
          deviceLocationView={deviceLocationView}
          clearSingleDevice={() => clearSingleDevice()}
          idDevice={selectedDevice.map((item: any) => item.id)}
          hasNotes={false}
          isMultipleControllerOldGeneration={selectedDevice.every(
            (device: any) => device.generation <= isOldGeneration
          )}
        />
      </StyledContainerItems>
    </div>
  );
};
